import { api } from '../api/client';

// Photos are fetched with the session's token, which an <img src> cannot
// send, and kept as object URLs by user and version for the page's life
// (spec 010 FR-027).
const cache = new Map<string, Promise<string | null>>();

export function photoUrl(userId: string, version: string): Promise<string | null> {
  const key = `${userId}@${version}`;
  let got = cache.get(key);
  if (!got) {
    got = api.blob(`/users/${userId}/photo`).then((b) => (b ? URL.createObjectURL(b) : null)).catch(() => null);
    cache.set(key, got);
  }
  return got;
}

// squareJpeg crops a picture's center to a square, shrinks it to at most 512
// by 512, and encodes it as a JPEG, as the apps do before upload.
export async function squareJpeg(file: File): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const side = Math.min(bitmap.width, bitmap.height);
  const out = Math.min(side, 512);
  const canvas = document.createElement('canvas');
  canvas.width = out;
  canvas.height = out;
  canvas.getContext('2d')!.drawImage(bitmap, (bitmap.width - side) / 2, (bitmap.height - side) / 2, side, side, 0, 0, out, out);
  return new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('could not encode the photo'))), 'image/jpeg', 0.85));
}
